'use client';
import { usePathname } from 'next/navigation';
import { SupportChatWidget } from './SupportChatWidget';

/**
 * The support/feedback widget belongs only on the public start page and the
 * contact page — not on every route. (It used to be mounted globally in the
 * root layout, so it showed up everywhere including the dashboards/admin.)
 */
export default function SupportChatWidgetGate() {
  const pathname = usePathname();
  if (pathname !== '/' && pathname !== '/kontakt') return null;
  return <SupportChatWidget />;
}
